// Shared, deterministic resolver: never silently choose a duplicate basename.
function normalize(target) {
  let value = String(target).split('|')[0].split('#')[0].trim();
  try { value = decodeURIComponent(value); } catch (_) { /* literal malformed URI */ }
  return value.replace(/\\/g, '/').replace(/^\.\//, '').replace(/\.md$/i, '').toLowerCase();
}
function resolveArchiveLink(docs, target, fromPath = '') {
  const key = normalize(target);
  if (!key) return null;
  const pathKey = (d) => normalize(d.relativePath);
  const unique = (items) => items.length === 1 ? items[0] : null;
  const exact = unique(docs.filter((d) => pathKey(d) === key));
  if (exact) return exact;
  if (fromPath) {
    const parts = normalize(fromPath).split('/'); parts.pop();
    for (const piece of key.split('/')) {
      if (piece === '..') parts.pop(); else if (piece !== '.') parts.push(piece);
    }
    const nearby = unique(docs.filter((d) => pathKey(d) === parts.join('/')));
    if (nearby) return nearby;
  }
  const suffix = unique(docs.filter((d) => pathKey(d).endsWith('/' + key)));
  if (suffix) return suffix;
  return unique(docs.filter((d) => normalize(d.title) === key || pathKey(d).split('/').pop() === key));
}
function buildArchiveGraph(docs) {
  const edges = [], unresolved = [], assetReferences = [], localAnchors = [];
  for (const d of docs) {
    const targets = new Set([...d.content.matchAll(/\[\[([^\]]+)\]\]/g)].map((m) => m[1].split('|')[0]));
    const found = new Map();
    for (const target of targets) {
      if (target.trim().startsWith('#')) { localAnchors.push({ from: d.id, target }); continue; }
      if (/\.(?:png|jpe?g|webp|gif|svg|pdf|docx?|html?|mp[34]|wav|ogg|blend|glb|uproject)$/i.test(target.split('#')[0])) { assetReferences.push({ from: d.id, target, reason: 'Non-markdown reference; its contents were not reviewed by the document graph.' }); continue; }
      const to = resolveArchiveLink(docs, target, d.relativePath);
      if (!to) { unresolved.push({ from: d.id, target, reason: 'missing or ambiguous public document; not auto-guessed' }); continue; }
      if (to.id === d.id) continue;
      if (!found.has(to.id)) found.set(to.id, []);
      found.get(to.id).push(target);
    }
    for (const [to, targets] of found) edges.push({ from: d.id, to, targets, kind: 'explicit-source-wikilink', reason: 'Source explicitly references this document; not a claim of canon precedence.' });
  }
  return { nodes: docs.map((d) => ({ id: d.id, title: d.title, relativePath: d.relativePath, section: d.section })), edges, unresolved, assetReferences, localAnchors };
}
module.exports = { resolveArchiveLink, buildArchiveGraph };
